import React from 'react';
function createElement(
/* eslint-disable @typescript-eslint/default-param-last */
as = 'div', { className, testId, innerRef, dangerouslySetStyle, children: commonPropsChildren, ...rest }, children) {
    return React.createElement(as, {
        'data-testid': testId,
        className,
        style: dangerouslySetStyle,
        ref: innerRef,
        ...rest,
    }, commonPropsChildren || children);
}
function withRef(Component, SubComponents) {
    var _a;
    const PureComponent = Component;
    const MainComponent = React.forwardRef((props, ref) => (
    /* eslint-disable react/jsx-props-no-spreading */
    /* @ts-ignore - TS gets severely confused by the `extends` clauses in HTMLDefaultProps */
    React.createElement(PureComponent, { ...props, innerRef: ref || (props === null || props === void 0 ? void 0 : props.innerRef) }))
    /* eslint-enable react/jsx-props-no-spreading */
    );
    if (SubComponents) {
        (_a = Object.keys(SubComponents)) === null || _a === void 0 ? void 0 : _a.forEach((subComponentName) => {
            MainComponent[subComponentName] = Component[subComponentName];
        });
    }
    MainComponent.displayName = (Component === null || Component === void 0 ? void 0 : Component.displayName) || 'withRef';
    return MainComponent;
}
export default {
    withRef,
    createElement,
};
//# sourceMappingURL=depot.js.map